<template>
  <app-modal>
    <el-card class="box-card">
      <h5 v-if="reloadComponent==0">
        <i class="el-icon-loading"></i> Espere a que termine de cargar los datos.
      </h5>
      <div v-if="!reloadComponent==0">
        <h2>Usuarios Que han leido la notificación</h2>
        <app-table-paginate
          v-if="reloadComponent!=0"
          :key="reloadComponent"
          routeDelete="no"
          selection="no"
          :tableQuery="tableQueryLeidas"
          :tableColumns="tableColumns"
          :search="false"
          :noDisplayActions="true"
        ></app-table-paginate>

        <h2>Usuarios Que han Comprendido la notificación</h2>
        <app-table-paginate
          v-if="reloadComponent!=0"
          :key="'r'+reloadComponent+1"
          routeDelete="no"
          selection="no"
          :tableQuery="tableQueryComprendidas"
          :tableColumns="tableColumns"
          :search="false"
          :noDisplayActions="true"
        ></app-table-paginate>
        <br />
        <br />
        <el-button @click="closeModal">cerrar</el-button>
      </div>
    </el-card>
  </app-modal>
</template>
<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import Modal from "@/components/Dashboard/Modals/modal";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";

export default {
  name: "modalShowUserWithNotification",
  props: ["id_notificacion"],
  components: {
    "app-modal": Modal,
    "app-table-paginate": tablaConPaginador
  },
  created() {
    this.getList();
    this.reloadComponent++;
  },
  data() {
    return {
      tableQueryLeidas: [],
      tableQueryComprendidas: [],
      reloadComponent: 0,
      tableColumns: [
        {
          prop: "user",
          label: "Usuario"
        }
      ]
    };
  },
  methods: {
    async getList() {
      const a = await ApiService.post("auditoria/notification-by-user", {
        token: localStorage.getItem("token"),
        id: this.id_notificacion
      });

      this.tableQueryLeidas = a.data.leidas;
      this.tableQueryComprendidas = a.data.comprendidas;
    },
    closeModal() {
      this.$root.$emit("closeModal");
    }
  }
};
</script>

<style scoped>
.item {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/auditoria/modals/showUsersWithNotifications.vue